// Coffrage
import * as THREE from "three";
import Experience from "../../Experience.js";

export default class PipeBoxing {
  constructor(scale, position = new THREE.Vector3(0, 0, 0), srcTexture = null, rotation) {
    this.experience = new Experience();
    this.scene = this.experience.scene;
    this.scale = scale;
    this.length = this.scale.x; 
    this.height = this.scale.y; 
    this.thickness = this.scale.z; 
    this.position = position;
    this.srcTexture = srcTexture;
    this.rotation = rotation || new THREE.Euler(0,0,0);

    this.objectManager = this.experience.objectManager;

    this.material = [
      new THREE.MeshStandardMaterial({ color: 0xffffff }), // +X
      new THREE.MeshStandardMaterial({ color: 0xffffff }), // -X
      new THREE.MeshStandardMaterial({ color: 0xffffff }), // +Y
      new THREE.MeshStandardMaterial({ color: 0xffffff }), // -Y
      new THREE.MeshStandardMaterial({ color: 0xffffff }), // +Z (intérieur)
      new THREE.MeshStandardMaterial({ color: 0xffffff }), // -Z
    ];

    this.geometry = new THREE.BoxGeometry(
      this.length,
      this.height,
      this.thickness
    );
    this.geometry.translate(0, this.height / 2, 0);
    // Creation PipeBoxing
    this.mesh = new THREE.Mesh(this.geometry, this.material);
    this.mesh.position.copy(this.position);
    this.mesh.position.y = 0.01;
    this.mesh.userData.collision = true;
    this.mesh.userData.snapping = false;
    this.mesh.name = "pipeBoxing";
    this.mesh.userData.type = "pipeBoxing";
    this.mesh.userData.instance = this;
    this.mesh.userData.scale = this.scale;
    this.mesh.userData.isBoxGeometry = true;

    this.textureLoader = this.experience.textureLoader;

    if(this.rotation) {
      this.mesh.rotation.copy(this.rotation);
    }

    if(this.srcTexture !== null){
      this.setTexture(this.srcTexture);
    }

    this.objectManager.addObjectCollision(this.mesh);
    this.objectManager.addObject(this.mesh);

    this.scene.add(this.mesh);
  }

  /**
   * Set length and thickness of PipeBoxing
   * @param {number} newLength - New length of PipeBoxing.
   * * @param {number} newThickness - New thickness of PipeBoxing.
   */
  setLengthAndThickness(newLength, newThickness) {
    this.length = newLength;
    this.thickness = newThickness;
    this.geometry.dispose();
    this.geometry = new THREE.BoxGeometry(
      this.length,
      this.height,
      this.thickness
    );
    this.mesh.geometry = this.geometry;
  }


  /**
   * Set texture
   */
  setTexture(textureUrl) {
    this.textureLoader.load(
      textureUrl,
      (texture) => {
        texture.colorSpace = THREE.SRGBColorSpace;
        texture.wrapS = THREE.RepeatWrapping;
        texture.wrapT = THREE.RepeatWrapping;
        texture.repeat.set(this.length, this.height);

        this.material[0] = new THREE.MeshStandardMaterial({ map: texture });
        this.material[1] = new THREE.MeshStandardMaterial({ map: texture });
        this.material[4] = new THREE.MeshStandardMaterial({ map: texture });
        this.material[5] = new THREE.MeshStandardMaterial({ map: texture });

        this.mesh.material = this.material;
        this.mesh.userData.texture = textureUrl;
      },
      undefined,
      (error) => {
        console.error("Erreur lors du chargement de la texture :", error);
      }
    );
  }
 
}
